;(function module() {
  angular.module('app.ui.form.ctrls').controller('IsOldBrowserController', [
    '$log',
    'sharedProperties',
    function controller($log, sharedProperties) {
      let vm = this
      vm.showOldBrowser = false
      vm.whichBrowser = {
        type: '',
        version: '',
      }
      vm.browser = sharedProperties.detectBrowser()
      if (vm.browser.includes('Chrome')) {
        vm.whichBrowser = {
          type: 'Chrome',
          version: vm.browser.slice(7, vm.browser.length),
        }
      } else if (vm.browser.includes('IE')) {
        vm.whichBrowser = {
          type: 'IE',
          version: vm.browser.slice(3, vm.browser.length),
        }
        if (vm.whichBrowser.version.includes('E')) {
          if (vm.whichBrowser.version === 'E 10') {
            vm.showOldBrowser = false
          } else if (vm.whichBrowser.version <= 'E 9') {
            vm.showOldBrowser = true
          }
        } else if (vm.whichBrowser.version >= '11') {
          vm.showOldBrowser = false
        }
      } else if (vm.browser.includes('Firefox')) {
        vm.whichBrowser = {
          type: 'Firefox',
          version: vm.browser.slice(8, vm.browser.length),
        }
      }

      return $log.info(vm.whichBrowser)
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/form/is-old-browser.ctrl.js